export default __webpack_public_path__ + "static/media/player-logo.b76ff860.png";